module.exports = __webpack_public_path__ + "static/media/SECONDS_RANK.fe1da4e5.svg";